import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity8 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_8;
}

export default DirtRoadTileEntity8;
